/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { socialProfileMatchedFactResponseDtoSchema } from "./socialProfileMatchedFactResponseDtoSchema";
import { z } from "zod/v4";

export const socialProfileSuggestionItemResponseDtoSchema = z.object({
    "id": z.uuid(),
"contactId": z.uuid(),
"platform": z.enum(["linkedin", "instagram", "facebook"]),
"url": z.string(),
"profileName": z.string(),
get "matchedFacts"(){
                return z.array(socialProfileMatchedFactResponseDtoSchema)
              },
"nameAmbiguity": z.enum(["unique", "some_overlap", "very_common"]),
"score": z.number().describe("Code-computed confidence, 0 to 1"),
"status": z.enum(["auto_accepted", "pending", "accepted", "rejected", "discarded"]),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })